<template>
  <div>
    <!-- 设备统计图表,接收在线离线设备数deviceOnline,deviceOffline -->
         <div class="leftcon">
           <div class="Echarts-Title">
             <p class="Echarts-Title-Text">{{$t('lang.dashboard.Equipment')}}({{deviceOnline+deviceOffline}})</p>
            </div>
             <v-chart :options="polar" :autoresize="true"/>
         </div>
  </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/polar'
export default {
  props:{
    deviceOnline:{
      type:Number
    },
    deviceOffline:{
      type:Number
    }
  },
  data(){
    let data = []
    for (let i = 0; i <= 360; i++) {
        let t = i / 180 * Math.PI
        let r = Math.sin(2 * t) * Math.cos(2 * t)
        data.push([r, i])
    }
    return{
    polar: {
        grid:{
        x:'0px',
        y:'0px',
        x2:'0px',
        y2:'0px'
    },
        tooltip: {
        trigger: 'item',
        position: [20, 20],
        formatter: `{b} : {c} <br/>${this.$t('lang.dashboard.form')} ：{d}%`
    },
    legend: {
        data:[],
        default: true
    },
    grid: {  
     left: '8%',  
     right: '0',  
    bottom: '1%',  
    containLabel: true  
    },  
    series: [
        {   
            name:'设备统计',
            type:'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
                normal: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    show: true,
                    textStyle: {
                        fontSize: '20',
                        fontWeight: 'bold'
                    }
                }
            },
            labelLine: {
                normal: {
                    show: false
                }
            },
            data:[
                {value:0, name:`${this.$t('lang.dashboard.online')}`},
                {value:0, name:`${this.$t('lang.dashboard.offline')}`}
            ],
            color:['#b1eadb','#ef4b4c']
        }
    ]
      }
      }
  },
  components: {
    'v-chart': ECharts
  },
  watch:{
    // 在线设备数量赋值
    deviceOnline:{
      handler(newValue, oldValue) {
        this.polar.series[0].data[0].value=newValue
      }
    },
    // 离线设备数量赋值
    deviceOffline:{
      handler(newValue, oldValue) {
        this.polar.series[0].data[1].value=newValue
      }
    }
  }
}
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 90%;
  margin: 0 auto;
}
.Echarts-Title{
  width: 100%;
  background-color: rgb(0, 116, 199);
}
.Echarts-Title-Text{
  color: #ffffff;
  font-size: 16px;
  margin-left: 10px;
  padding-top:5px;
  padding-bottom: 5px;
  font-weight: bold;
}
.leftcon{
    background-color: rgb(0, 116, 199);
    height: 25vh;
    border-radius:2%;
    width: 100%;
    margin-bottom: 0.2rem;
    overflow: hidden;
}
.leftcon .text{
  color: #ffffff;
  font-size:0.35rem;
  text-align: center;
  padding-top:0.1rem; 
}
.radius{
  margin-top:0.2rem;
  margin-left: 0.5rem; 
  display: inline-block;
  float: left;
}
.radiustext{
  color: #ffffff;
  text-indent: 0.2rem;
  font-size: 0.3rem;
  margin-top: 0.6rem;
}
.progress{
  display: inline-block;
  color: #ffffff;
}
.leftdiv{
  float: left;
}
</style>
